import {
  createJoinApplication as publicCreateJoinApplication,
  getJoinApplication as publicGetJoinApplication,
  deleteJoinApplication as publicDeleteJoinApplication,
  queryJoinApplications as publicQueryJoinApplications,
  typedQueryJoinApplications as publicTypedQueryJoinApplications,
  searchJoinApplications as publicSearchJoinApplications,
  bulkCreateJoinApplications as publicBulkCreateJoinApplications,
  bulkDeleteJoinApplications as publicBulkDeleteJoinApplications,
  getCurrentJoinApplication as publicGetCurrentJoinApplication,
  myJoinApplication as publicMyJoinApplication,
  approveJoinApplication as publicApproveJoinApplication,
  declineJoinApplication as publicDeclineJoinApplication,
  cancelJoinApplication as publicCancelJoinApplication,
  acceptInvite as publicAcceptInvite,
  bulkUpdateJoinApplicationTags as publicBulkUpdateJoinApplicationTags,
  bulkUpdateJoinApplicationTagsByFilter as publicBulkUpdateJoinApplicationTagsByFilter,
  preparePayment as publicPreparePayment,
  applyCoupon as publicApplyCoupon,
  removeCoupon as publicRemoveCoupon,
  completeFreeCouponPayment as publicCompleteFreeCouponPayment,
  bulkInviteMembersToProgramByFilter as publicBulkInviteMembersToProgramByFilter,
} from './online-programs-participants-v3-join-application-join-applications.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  JoinApplicationQuery,
  JoinApplicationsQueryBuilder,
  typedQueryJoinApplications as universalTypedQueryJoinApplications,
} from './online-programs-participants-v3-join-application-join-applications.universal.js';
import { onJoinApplicationCreated as publicOnJoinApplicationCreated } from './online-programs-participants-v3-join-application-join-applications.public.js';
import { onJoinApplicationDeleted as publicOnJoinApplicationDeleted } from './online-programs-participants-v3-join-application-join-applications.public.js';
import { onJoinApplicationPaymentStatusChanged as publicOnJoinApplicationPaymentStatusChanged } from './online-programs-participants-v3-join-application-join-applications.public.js';
import { onJoinApplicationStatusChanged as publicOnJoinApplicationStatusChanged } from './online-programs-participants-v3-join-application-join-applications.public.js';
import { onJoinApplicationTagsModified as publicOnJoinApplicationTagsModified } from './online-programs-participants-v3-join-application-join-applications.public.js';
import { onJoinApplicationUpdated as publicOnJoinApplicationUpdated } from './online-programs-participants-v3-join-application-join-applications.public.js';

function customQueryJoinApplications(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryJoinApplications(httpClient)(),
    typedQueryFunction: (query: JoinApplicationQuery) =>
      publicTypedQueryJoinApplications(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): JoinApplicationsQueryBuilder;
  function overloadedQuery(
    query: JoinApplicationQuery
  ): ReturnType<typeof universalTypedQueryJoinApplications>;
  function overloadedQuery(query?: JoinApplicationQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createJoinApplication: MaybeContext<
  BuildRESTFunction<typeof publicCreateJoinApplication> &
    typeof publicCreateJoinApplication
> = /*#__PURE__*/ createRESTModule(publicCreateJoinApplication);
export const getJoinApplication: MaybeContext<
  BuildRESTFunction<typeof publicGetJoinApplication> &
    typeof publicGetJoinApplication
> = /*#__PURE__*/ createRESTModule(publicGetJoinApplication);
export const deleteJoinApplication: MaybeContext<
  BuildRESTFunction<typeof publicDeleteJoinApplication> &
    typeof publicDeleteJoinApplication
> = /*#__PURE__*/ createRESTModule(publicDeleteJoinApplication);
export const searchJoinApplications: MaybeContext<
  BuildRESTFunction<typeof publicSearchJoinApplications> &
    typeof publicSearchJoinApplications
> = /*#__PURE__*/ createRESTModule(publicSearchJoinApplications);
export const bulkCreateJoinApplications: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateJoinApplications> &
    typeof publicBulkCreateJoinApplications
> = /*#__PURE__*/ createRESTModule(publicBulkCreateJoinApplications);
export const bulkDeleteJoinApplications: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteJoinApplications> &
    typeof publicBulkDeleteJoinApplications
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteJoinApplications);
export const getCurrentJoinApplication: MaybeContext<
  BuildRESTFunction<typeof publicGetCurrentJoinApplication> &
    typeof publicGetCurrentJoinApplication
> = /*#__PURE__*/ createRESTModule(publicGetCurrentJoinApplication);
export const myJoinApplication: MaybeContext<
  BuildRESTFunction<typeof publicMyJoinApplication> &
    typeof publicMyJoinApplication
> = /*#__PURE__*/ createRESTModule(publicMyJoinApplication);
export const approveJoinApplication: MaybeContext<
  BuildRESTFunction<typeof publicApproveJoinApplication> &
    typeof publicApproveJoinApplication
> = /*#__PURE__*/ createRESTModule(publicApproveJoinApplication);
export const declineJoinApplication: MaybeContext<
  BuildRESTFunction<typeof publicDeclineJoinApplication> &
    typeof publicDeclineJoinApplication
> = /*#__PURE__*/ createRESTModule(publicDeclineJoinApplication);
export const cancelJoinApplication: MaybeContext<
  BuildRESTFunction<typeof publicCancelJoinApplication> &
    typeof publicCancelJoinApplication
> = /*#__PURE__*/ createRESTModule(publicCancelJoinApplication);
export const acceptInvite: MaybeContext<
  BuildRESTFunction<typeof publicAcceptInvite> & typeof publicAcceptInvite
> = /*#__PURE__*/ createRESTModule(publicAcceptInvite);
export const bulkUpdateJoinApplicationTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateJoinApplicationTags> &
    typeof publicBulkUpdateJoinApplicationTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateJoinApplicationTags);
export const bulkUpdateJoinApplicationTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateJoinApplicationTagsByFilter> &
    typeof publicBulkUpdateJoinApplicationTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateJoinApplicationTagsByFilter);
export const preparePayment: MaybeContext<
  BuildRESTFunction<typeof publicPreparePayment> & typeof publicPreparePayment
> = /*#__PURE__*/ createRESTModule(publicPreparePayment);
export const applyCoupon: MaybeContext<
  BuildRESTFunction<typeof publicApplyCoupon> & typeof publicApplyCoupon
> = /*#__PURE__*/ createRESTModule(publicApplyCoupon);
export const removeCoupon: MaybeContext<
  BuildRESTFunction<typeof publicRemoveCoupon> & typeof publicRemoveCoupon
> = /*#__PURE__*/ createRESTModule(publicRemoveCoupon);
export const completeFreeCouponPayment: MaybeContext<
  BuildRESTFunction<typeof publicCompleteFreeCouponPayment> &
    typeof publicCompleteFreeCouponPayment
> = /*#__PURE__*/ createRESTModule(publicCompleteFreeCouponPayment);
export const bulkInviteMembersToProgramByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkInviteMembersToProgramByFilter> &
    typeof publicBulkInviteMembersToProgramByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkInviteMembersToProgramByFilter);
export const queryJoinApplications: MaybeContext<
  BuildRESTFunction<typeof customQueryJoinApplications> &
    typeof customQueryJoinApplications
> = /*#__PURE__*/ createRESTModule(customQueryJoinApplications);
/**
 * Triggered when a join application is created.
 */
export const onJoinApplicationCreated: BuildEventDefinition<
  typeof publicOnJoinApplicationCreated
> &
  typeof publicOnJoinApplicationCreated = /*#__PURE__*/ createEventModule(
  publicOnJoinApplicationCreated
);
/**
 * Triggered when a join application is deleted.
 */
export const onJoinApplicationDeleted: BuildEventDefinition<
  typeof publicOnJoinApplicationDeleted
> &
  typeof publicOnJoinApplicationDeleted = /*#__PURE__*/ createEventModule(
  publicOnJoinApplicationDeleted
);
/**
 * Triggered when a join application's `paymentStatus` changes.
 */
export const onJoinApplicationPaymentStatusChanged: BuildEventDefinition<
  typeof publicOnJoinApplicationPaymentStatusChanged
> &
  typeof publicOnJoinApplicationPaymentStatusChanged =
  /*#__PURE__*/ createEventModule(publicOnJoinApplicationPaymentStatusChanged);
/**
 * Triggered when a join application's `status` changes.
 */
export const onJoinApplicationStatusChanged: BuildEventDefinition<
  typeof publicOnJoinApplicationStatusChanged
> &
  typeof publicOnJoinApplicationStatusChanged = /*#__PURE__*/ createEventModule(
  publicOnJoinApplicationStatusChanged
);
/**
 * Triggered when tags on a join application are modified.
 */
export const onJoinApplicationTagsModified: BuildEventDefinition<
  typeof publicOnJoinApplicationTagsModified
> &
  typeof publicOnJoinApplicationTagsModified = /*#__PURE__*/ createEventModule(
  publicOnJoinApplicationTagsModified
);
/**
 * Triggered when a join application is updated.
 */
export const onJoinApplicationUpdated: BuildEventDefinition<
  typeof publicOnJoinApplicationUpdated
> &
  typeof publicOnJoinApplicationUpdated = /*#__PURE__*/ createEventModule(
  publicOnJoinApplicationUpdated
);

export {
  Status,
  PaymentStatus,
  SortOrder,
  SortType,
  SortDirection,
  MissingValues,
  ScalarType,
  NestedAggregationType,
  Interval,
  AggregationType,
  Mode,
  BulkActionType,
  PaymentType,
  EventType,
  OrderItemCategory,
  SubdivisionType,
  VatType,
  TransactionStatus,
  ScheduledActionType,
  RefundStatus,
  RecurringPaymentStatusStatus,
  Initiator,
  BenefitType,
  Event,
  WebhookIdentityType,
} from './online-programs-participants-v3-join-application-join-applications.universal.js';
export {
  JoinApplication,
  PaymentInfo,
  Member,
  ExtendedFields,
  Tags,
  TagList,
  ReindexMessage,
  ReindexMessageActionOneOf,
  Upsert,
  Delete,
  Schema,
  JoinApplicationTagsModified,
  StatusChanged,
  PaymentStatusChanged,
  CreateJoinApplicationRequest,
  CreateJoinApplicationResponse,
  GetJoinApplicationRequest,
  GetJoinApplicationResponse,
  DeleteJoinApplicationRequest,
  DeleteJoinApplicationResponse,
  QueryJoinApplicationsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryJoinApplicationsResponse,
  PagingMetadataV2,
  Cursors,
  SearchJoinApplicationsRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Aggregation,
  AggregationKindOneOf,
  RangeBucket,
  IncludeMissingValuesOptions,
  ValueAggregation,
  ValueAggregationOptionsOneOf,
  RangeAggregation,
  ScalarAggregation,
  DateHistogramAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregation,
  SearchDetails,
  SearchJoinApplicationsResponse,
  CursorPagingMetadata,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  ValueResults,
  RangeResults,
  AggregationResultsScalarResult,
  NestedValueAggregationResult,
  ValueResult,
  RangeResult,
  ScalarResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  DateHistogramResult,
  GroupByValueResults,
  DateHistogramResults,
  NestedResults,
  AggregationResults,
  AggregationResultsResultOneOf,
  BulkCreateJoinApplicationsRequest,
  BulkCreateJoinApplicationsResponse,
  ItemMetadata,
  ApplicationError,
  BulkJoinApplicationResult,
  BulkActionMetadata,
  BulkUpsertJoinApplicationMigrationRequest,
  JoinApplicationMigration,
  BulkUpsertJoinApplicationMigrationResponse,
  BulkJoinApplicationMigrationResult,
  BulkDeleteJoinApplicationsRequest,
  BulkDeleteJoinApplicationsResponse,
  BulkDeleteJoinApplicationsResponseBulkJoinApplicationResult,
  GetCurrentJoinApplicationRequest,
  GetCurrentJoinApplicationResponse,
  MyJoinApplicationRequest,
  MyJoinApplicationResponse,
  ApproveJoinApplicationRequest,
  ApproveJoinApplicationResponse,
  DeclineJoinApplicationRequest,
  DeclineJoinApplicationResponse,
  CancelJoinApplicationRequest,
  CancelJoinApplicationResponse,
  AcceptInviteRequest,
  AcceptInviteResponse,
  BulkUpdateJoinApplicationTagsRequest,
  BulkUpdateJoinApplicationTagsResponse,
  BulkUpdateJoinApplicationTagsResult,
  BulkUpdateJoinApplicationTagsByFilterRequest,
  BulkUpdateJoinApplicationTagsByFilterResponse,
  PreparePaymentRequest,
  PreparePaymentResponse,
  ApplyCouponRequest,
  ApplyCouponResponse,
  RemoveCouponRequest,
  RemoveCouponResponse,
  CompleteFreeCouponPaymentRequest,
  CompleteFreeCouponPaymentResponse,
  BulkInviteMembersToProgramByFilterRequest,
  BulkInviteMembersToProgramByFilterResponse,
  DeleteAllJoinApplicationsMigrationRequest,
  DeleteAllJoinApplicationsMigrationResponse,
  ReindexJoinApplicationsSearchRequest,
  ReindexJoinApplicationsSearchResponse,
  SyncPaymentExpirationTasksMigrationRequest,
  SyncPaymentExpirationTasksMigrationResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  PaymentEvent,
  PaymentEventEventOneOf,
  TransactionStatusChangedEvent,
  Order,
  OrderItem,
  OrderAdditionalCharges,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  StandardDetails,
  FullAddressContactDetails,
  VatId,
  Transaction,
  TransactionPaymentMethodDataOneOf,
  CurrencyAmount,
  RecurringPaymentDetails,
  CreditCardPaymentMethodData,
  V3AccountInfo,
  ScheduledAction,
  RefundStatusChangedEvent,
  Refund,
  RecurringPaymentStatusChangedEvent,
  RecurringPaymentCancellationDetails,
  TransactionUpdatedEvent,
  TransactionCreatedEvent,
  BenefitNotification,
  Benefit,
  EntryPass,
  Discount,
  DiscountDiscountOneOf,
  Behavior,
  BehaviorBehaviorOneOf,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  JoinApplicationCreatedEnvelope,
  JoinApplicationDeletedEnvelope,
  JoinApplicationPaymentStatusChangedEnvelope,
  JoinApplicationStatusChangedEnvelope,
  JoinApplicationTagsModifiedEnvelope,
  JoinApplicationUpdatedEnvelope,
  JoinApplicationsQueryResult,
  JoinApplicationsQueryBuilder,
  JoinApplicationQuerySpec,
  JoinApplicationSearchSpec,
  BulkCreateJoinApplicationsOptions,
  BulkUpdateJoinApplicationTagsOptions,
  BulkUpdateJoinApplicationTagsByFilterOptions,
  BulkInviteMembersToProgramByFilterOptions,
} from './online-programs-participants-v3-join-application-join-applications.universal.js';
export { utils } from './online-programs-participants-v3-join-application-join-applications.universal.js';
export {
  StatusWithLiterals,
  PaymentStatusWithLiterals,
  SortOrderWithLiterals,
  SortTypeWithLiterals,
  SortDirectionWithLiterals,
  MissingValuesWithLiterals,
  ScalarTypeWithLiterals,
  NestedAggregationTypeWithLiterals,
  IntervalWithLiterals,
  AggregationTypeWithLiterals,
  ModeWithLiterals,
  BulkActionTypeWithLiterals,
  PaymentTypeWithLiterals,
  EventTypeWithLiterals,
  OrderItemCategoryWithLiterals,
  SubdivisionTypeWithLiterals,
  VatTypeWithLiterals,
  TransactionStatusWithLiterals,
  ScheduledActionTypeWithLiterals,
  RefundStatusWithLiterals,
  RecurringPaymentStatusStatusWithLiterals,
  InitiatorWithLiterals,
  BenefitTypeWithLiterals,
  EventWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateJoinApplicationApplicationErrors,
  BulkCreateJoinApplicationsApplicationErrors,
  GetCurrentJoinApplicationApplicationErrors,
  MyJoinApplicationApplicationErrors,
  ApproveJoinApplicationApplicationErrors,
  DeclineJoinApplicationApplicationErrors,
  CancelJoinApplicationApplicationErrors,
  AcceptInviteApplicationErrors,
  BulkUpdateJoinApplicationTagsApplicationErrors,
  BulkUpdateJoinApplicationTagsByFilterApplicationErrors,
  PreparePaymentApplicationErrors,
  ApplyCouponApplicationErrors,
  RemoveCouponApplicationErrors,
  CompleteFreeCouponPaymentApplicationErrors,
  BulkInviteMembersToProgramByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  JoinApplicationQuery,
  CommonSearchWithEntityContext,
  JoinApplicationSearch,
} from './online-programs-participants-v3-join-application-join-applications.universal.js';
